package org.hs_soft.runmynesto.domain.model.general

enum class ButtonTypes {
    CONTAINED,
    OUTLINED,
    TEXT
}
